import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseRemoveFiscalDocument {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}


const useBillingFiscalDocumentGroupRemoveFiscalDocument = ({ id, onSuccess, onError }: UseRemoveFiscalDocument) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['billingFiscalDocumentGroupRemoveFiscalDocument'],
    mutationFn: async () => {
      return await privateAxios.put(`/billing/fiscal_document_groups/${id}/remove_fiscal_document`)
    },
    onSuccess,
    onError
  })
}

export default useBillingFiscalDocumentGroupRemoveFiscalDocument
